import { formatPhone } from '@apply/ui';
export interface PhoneProps {
    phoneNumber: string | undefined;
}

export const Phone: React.FC<PhoneProps> = ({ phoneNumber }) => {
    return (
        <>
            <div className='manageUsersByUserTable-generalContractor-phone'>
                {phoneNumber && formatPhone(phoneNumber)}
                {!phoneNumber && <div className='manageUsersByUserTable-generalContractor-phone-none'>No Phone Assigned</div>}
            </div>
        </>
    );
};
